import cn from "classnames"
import { Fragment } from "react"

import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { ViolatedCell } from "../../../AiPoliciesPage/components/ViolatedCell"
import { CardTemplate } from "../CardTemplate/CardTemplate"
import { ActionsRuleCard } from "./ActionsRuleCard"
import { RuleCondition } from "./RuleCondition"

import styles from "./RuleCard.module.scss"

import type { RuleCardProps } from "./RuleCard.types"

export const RuleCard = (props: RuleCardProps) => {
  const { type, data, violated, mode, prefix, openDrawer } = props
  const { t } = useTranslation()
  const { features } = useAiPolicies()
  const { rules, actions } = data
  const { enabled, ...restActions } = actions

  return (
    <CardTemplate type={type}>
      <Flex vertical flex={1} gap={prefix ? 16 : 0}>
        {prefix}
        <Flex vertical gap={6} flex={1}>
          {features.enforcement && mode !== "drawer" && (
            <Text type="secondary" className="sm-text-ks">
              {t("governance.ai.live.form.rule.allMatch")}
            </Text>
          )}
          {rules.map((rule, index) => {
            return (
              <Fragment key={rule.id}>
                <Flex gap={16} align="start">
                  <RuleCondition rule={rule} />
                  {mode !== "drawer" && (
                    <Flex
                      gap={28}
                      align="center"
                      className={styles.actionsWrapper}
                    >
                      <Flex gap={12} align="center">
                        <span
                          className={cn(
                            styles.arrow,
                            enabled &&
                              Object.values(restActions).some(Boolean) &&
                              styles.arrowEnabled
                          )}
                        >
                          →
                        </span>
                        <ActionsRuleCard actions={actions} />
                      </Flex>
                      {features.violations && (
                        <Flex
                          className={cn(
                            styles.status,
                            violated && openDrawer && styles.violation
                          )}
                          onClick={violated ? openDrawer : undefined}
                        >
                          {ViolatedCell(violated)}
                        </Flex>
                      )}
                    </Flex>
                  )}
                </Flex>
                {index < rules.length - 1 && (
                  <span className={styles.and}>AND</span>
                )}
              </Fragment>
            )
          })}
        </Flex>
      </Flex>
    </CardTemplate>
  )
}
